import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import { get, post, put } from "../../helpers/api_helper";
import { toast } from "react-toastify";

// availity-reactstrap-validation

// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Utils from "../Utility";

// actions

import Table from "./Table";
import Loader from "../../components/Loader";
import {
  AvCheckbox,
  AvCheckboxGroup,
  AvField,
  AvForm,
} from "availity-reactstrap-validation";
import moment from "moment";
import { useHistory } from "react-router-dom";
const Property = (props) => {
  const { user } = props;
  const history = useHistory();
  const [currentData, setCurrentData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user?.token) {
      getData();
    }
  }, [user]);

  const getData = ()=>{
    get("/lastUpdate", {token: user?.token})
    .then(res=>{
      if(res?.statusCode==200)
        setCurrentData(res?.data[0]);
    })
  }

  const handleValidSubmit = async (e, v) => {
    let body = {
      ...v,
    };

    setLoading(true);

    if (currentData) {
      body = { ...body, lastUpdateId: currentData?._id };
      put("/lastUpdate", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            toast.success(res?.message);
            getData();
            // history.goBack();
            // setIsAddForm(false);
          } else {
            toast.error(res?.error);
          }
        })
        .catch((err) => {
          toast.error(err);
          setLoading(false);
        });
    } else {
      post("/lastUpdate", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            toast.success(res?.message);
            getData();
            console.log("res from tender", res);
          } else {
            toast.error(res?.error);
          }
        })
        .catch((err) => {
          toast.error(err);
          setLoading(false);
        });
    }
  };

  return (
    <>
      <div className="page-content">
        <Loader visible={loading} />
        {/* Render Breadcrumb */}
        <Breadcrumb
          title={Utils.projectName}
          breadcrumbItem={currentData ? `Last Update!` : `Add Last Update`}
        />

        <div className="main-box-form main_box_form_all">
          <div className="table_top_header">
            <CardTitle className="h4">
              <i class="mdi mdi-pencil"></i> Last Updated{" "}
            </CardTitle>
          </div>
          <Card style={{ borderRadius: "0" }}>
            <CardBody>
              <AvForm
                className="form-horizontal"
                onValidSubmit={(e, v) => {
                  console.log("Form data submitted:", v);
                  handleValidSubmit(e, v, "bank");
                }}
              >
                <Row>
                  <Col lg={6} md={12}>
                    <div className="mb-3">
                      <AvField
                        name="last_updated"
                        label="Select date *"
                        className="form-control"
                        placeholder=""
                        type="date"
                        value={moment(currentData?.last_updated).format("YYYY-MM-DD")}
                        required
                        // value={currentData?.name}
                      />
                    </div>
                  </Col>
                </Row>
                <div className="mt-4">
                  <Row>
                    {currentData && (
                      <Col md={6}>
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          style={{
                            backgroundColor: Utils.themeColor1,
                            border: "none",
                          }}
                          onClick={() => {
                            history.goBack();
                          }}
                          type="reset"
                        >
                          Cancel
                        </button>
                      </Col>
                    )}
                    <Col md={6}>
                      <button
                        className="btn btn-primary w-100 waves-effect waves-light"
                        type="submit"
                        style={{
                          backgroundColor: Utils.themeColor,
                          border: "none",
                        }}
                      >
                        {currentData ? "Update" : "Submit"}
                      </button>
                    </Col>
                  </Row>
                </div>
              </AvForm>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
};

Property.propTypes = {
  getProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
  companyError: PropTypes.func,
  companySuccess: PropTypes.func,
  createCompany: PropTypes.func,
  updateCompany: PropTypes.func,
};

const mapStatetoProps = (state) => {
  const { user } = state.Profile;
  console.log("user mat", user);
  const { company } = state.Company;
  return { user, company };
};

export default withRouter(connect(mapStatetoProps, {})(Property));
